import PropTypes from "prop-types";


import { apiClient, getErrorMessage } from "../../shared";
import { useSnackbar } from "../../ui";
import { PaymentTermFormDialog } from "../payment-term-form-dialog";

import { Button } from "@mui/material";

export const AddPaymentTermFormDialog = ({ onClose, onSubmitted }) => {
  const { showSnackbar } = useSnackbar();

  const handleSubmit = async (formData) => {
    try {
      await apiClient.post("payment-terms", formData);

      onSubmitted();
      onClose();
    } catch (error) {
      showSnackbar(getErrorMessage(error, "Gagal menambahkan syarat pembayaran"));

      throw error;
    }
  };

  return (
    <PaymentTermFormDialog
      onClose={onClose}
      dialogTitle="Tambah Syarat Pembayaran"
      onSubmit={handleSubmit}
      renderDialogActionsChildren={({ isLoading }) => (
        <Button loading={isLoading} variant="contained" type="submit">
          Tambah
        </Button>
      )}
    />
  );
};

AddPaymentTermFormDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmitted: PropTypes.func.isRequired,
};
